import Acl from '../../../lib/acl'
import React from 'react'
import { MenuItemContent } from './menu-item-content'
import PropTypes from 'prop-types'

function MenuItem (props) {
  const { navigateTo, href, ...other } = props

  if (!Acl.isPageAllowed(props.id)) return null

  if (href) {
    return (
      <a className='sidebar__menu-item-anchor' href={href}>
        <MenuItemContent {...other} />
      </a>
    )
  }

  return <MenuItemContent {...other} onClick={() => navigateTo(props.id)} />
}

MenuItem.propTypes = {
  navigateTo: PropTypes.func,
  href: PropTypes.string
}

export { MenuItem }
